/**
 * Design desktop first and then use media queries to transform styles.
 * Test from width 340px and bigger;
 */
export const device = {
  XS: '(max-width: 420px)',
  S: '(max-width: 720px)',
  M: '(max-width: 1024px)',
  L: '(max-width: 1366px)',
  XL: '(min-width: 1367px)',
}
